import { useState } from "react";
import { ArrowDown, ArrowUp } from "lucide-react";

export type SortOption = "alphabetical" | "averageKPI" | "role";
export type SortDirection = "asc" | "desc";

interface PlayersSortProps {
    onSortChange: (sortOption: SortOption, direction: SortDirection) => void;
}

const sortItems = [
    { value: "alphabetical" as SortOption, label: "Alphabetical", shortLabel: "A–Z" },
    { value: "averageKPI" as SortOption, label: "Average KPI", shortLabel: "KPI" },
    { value: "role" as SortOption, label: "Role", shortLabel: "Role" },
];

export function PlayersSort({ onSortChange }: PlayersSortProps) {
    const [activeSort, setActiveSort] = useState<SortOption>("averageKPI");
    const [sortDirection, setSortDirection] = useState<SortDirection>("desc");

    const handleSortClick = (sortOption: SortOption) => {
        if (activeSort === sortOption) {
            const newDirection = sortDirection === "desc" ? "asc" : "desc";
            setSortDirection(newDirection);
            onSortChange(sortOption, newDirection);
        } else {
            setActiveSort(sortOption);
            setSortDirection("desc");
            onSortChange(sortOption, "desc");
        }
    };

    return (
        <nav id="onboarding-players-sort" className="rounded-md p-1 mb-3 bg-surface-container-low">
            <div className="grid grid-cols-3 gap-1 md:flex md:items-center md:space-x-2 md:gap-0">
                {sortItems.map((item) => {
                    const isActive = activeSort === item.value;
                    return (
                        <button
                            key={item.value}
                            type="button"
                            className={`nav-tab ${isActive ? "nav-tab-active" : "nav-tab-inactive"}`}
                            onClick={() => handleSortClick(item.value)}
                        >
                            <div className="flex gap-1.5 items-center justify-center">
                                <span className="md:hidden">{item.shortLabel}</span>
                                <span className="hidden md:inline">{item.label}</span>
                                {isActive && (
                                    <span>
                                        {sortDirection === "asc" ? (
                                            <ArrowUp
                                                className="h-3.5 w-3.5"
                                                style={{ color: "var(--color-general-red)" }}
                                            />
                                        ) : (
                                            <ArrowDown
                                                className="h-3.5 w-3.5"
                                                style={{ color: "var(--color-general-green)" }}
                                            />
                                        )}
                                    </span>
                                )}
                            </div>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}
